var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.cancelButtonLabel')}},[_c('el-input',{attrs:{"type":"text"},model:{value:(_vm.optionModel.cancelButtonLabel),callback:function ($$v) {_vm.$set(_vm.optionModel, "cancelButtonLabel", $$v)},expression:"optionModel.cancelButtonLabel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }